import { Dialog } from "primereact/dialog"
import styles from "../../../styles/Participant-GPRA.module.css"
import { InputSwitch } from "primereact/inputswitch"
import { Button } from "primereact/button"
import { useState } from "react"
import { useEffect } from "react"
import Conditional from "./Conditional"
import { existsErrors } from "../utils/utils"
import { errorMessages } from "../types/messages"

const EditDefaultQuestion = ({
  showEditDefault,
  setShowEditDefault,
  defaultQuestion,
  questions,
  updateQuestions,
  section,
  interviewType,
}) => {
  const [validationErrors, setValidationErrors] = useState({})
  const [editedDefault, setEditedDefault] = useState({
    enterpriseCustomization: "",
    field: "",
    id: "",
    interviewType: "",
    isEnterprise: "",
    label: "",
    organizationId: "",
    questionNumber: "",
    relatedTo: "",
    section: "",
    show: false,
    subQuestionNumber: "",
    toggleOffBy: "",
    toggleOffDate: "",
    conditionalSource: "",
    conditionalType: "",
    conditionalValue: "",
    conditionalDisplay: false,
    conditionalRequired: false,
  })
  useEffect(() => {
    if (defaultQuestion) {
      setEditedDefault(defaultQuestion)
    }
  }, [defaultQuestion])

  const validationForm = () => {
    let errors = {}

    setValidationErrors(errors)
    return existsErrors(errors)
  }
  const clearValues = () => {
    setEditedDefault({
      enterpriseCustomization: "",
      field: "",
      id: "",
      interviewType: "",
      isEnterprise: "",
      label: "",
      organizationId: "",
      questionNumber: "",
      relatedTo: "",
      section: "",
      show: false,
      subQuestionNumber: "",
      toggleOffBy: "",
      toggleOffDate: "",
      conditionalSource: "",
      conditionalType: "",
      conditionalValue: "",
      conditionalEnabled: false,
      conditionalRequired: false,
    })
    setValidationErrors({})
  }

  const update = () => {
    if (validationForm()) {
      const updatedValues = questions?.customizations?.map((c) => {
        let newValue = { ...c }
        if (c.field === editedDefault.field) {
          newValue.show = editedDefault.show
          newValue.conditionalSource = editedDefault.conditionalSource
          newValue.conditionalType = editedDefault.conditionalType
          newValue.conditionalValue = editedDefault.conditionalValue
          newValue.conditionalRequired = editedDefault.conditionalRequired
          newValue.conditionalDisplay = editedDefault.conditionalDisplay
        }
        return newValue
      })
      updateQuestions({ ...questions, customizations: updatedValues })
      setShowEditDefault(false)
      clearValues()
    }
  }
  const footer = () => {
    return (
      <>
        <div>
          <Button
            label="Cancel"
            icon="pi pi-times"
            onClick={() => {
              clearValues()
              setShowEditDefault(false)
            }}
            className="p-button-text"
          />
          <Button
            label="Ok"
            icon={"pi pi-check"}
            onClick={() => {
              // update(defaultQuestion.id, show)
              update()
            }}
            autoFocus
          />
        </div>
      </>
    )
  }
  return (
    <Dialog
      header={"Edit default question"}
      visible={showEditDefault}
      onHide={() => setShowEditDefault(false)}
      breakpoints={{ "960px": "40vw" }}
      style={{ width: "35vw" }}
      footer={footer()}
      closable={false}
      blockScroll={true}
    >
      <div style={{ display: "flex", marginTop: "1rem", marginBottom: "2rem" }}>
        <label className={styles.mr2} htmlFor="binary">
          Enabled
        </label>
        <InputSwitch
          checked={editedDefault?.show}
          onChange={(e) => {
            setEditedDefault({ ...editedDefault, show: e.value })
          }}
        />
      </div>
    </Dialog>
  )
}
export default EditDefaultQuestion
